module.exports = {"Description":"RU : NNN[-NNN]","RedundantCharacters":" -","ValidationRegex":"^[0-9]{3}([0-9]{3})?$","TestData":{"Valid":["125","123456"],"Invalid":["x1231s","1231sd","1010101010"]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/postal-codes-js/formats/RU.json
// module id = 4484
// module chunks = 11